<template>
  <div>
   <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <ScroolTop ></ScroolTop>
    <!-- <back-link v-if="this.$route.meta.routerBack !== false"></back-link> -->
  </div>
</template>
<script>
// import backLink from '@/components/BackLink/index.vue'
import ScroolTop from '@/components/ScrollTop'


export default {
  components: {
    // backLink
    ScroolTop
  },
  data () {
    return {
      showScrollTop: false
    }
  },
  activated () {
    if (this.$route.meta.showScrollTop) {
      this.showScrollTop = true
    } else {
      this.showScrollTop = false
    }
  }
  // data () {
  //   return {
  //   }
  // },
}
</script>